import fetch from 'isomorphic-fetch';
import { push } from 'react-router-redux';
import { checkStatus } from '../util';
import { ROOT } from '../../constants/root';
import { Event } from "../../GAnalytics";
import { setNome, setSobrenome, setEmail, setUsername,
	setMariana, setBrumadinho, setNewUserGroups, setEdit, setID } from "../manageuser/actions";
import { prettyAlert } from '../../components/Common/Dialog';

export function getListUsers() {
	return function(dispatch, getState) {		
		
		// Builds credentials
		const URL = `${ROOT}/user/manage_user/`;		

		// Set visual UI
		// dispatch(isFetchingExplorer(true));		

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {			
			dispatch(setListUsers(json));
			// dispatch(isFetchingExplorer(false));
		})
		.catch((e) => {
			// dispatch(isFetchingExplorer(false));
			console.error(e);			
		});
	};
}

export function getAccessLogList() {
	return function(dispatch, getState) {		
		
		// Builds credentials
		const URL = `${ROOT}/user/manage_user/access_log/`;		

		// Set visual UI
		// dispatch(isFetchingExplorer(true));		

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			let list = [];
			json.map((log) => {
				const details = JSON.parse(log.value);
				list.push({
					id: log.id,
					date: log.timestamp,
					nome: `${details.first_name} ${details.last_name}`,
					email: details.email,
					username: details.username
				});
			});
			dispatch(setAccessLog(list));
			// dispatch(isFetchingExplorer(false));
		})
		.catch((e) => {
			// dispatch(isFetchingExplorer(false));
			console.error(e);			
		});
	};
}

function setAccessLog(accessLog) {
	return {
		type: "SET_ACCESS_LOG",
		accessLog
	};	
}

export function getManagerUserPermissions() {
	return function(dispatch, getState) {		
		
		// Builds credentials
		const URL = `${ROOT}/user/manage_user/perms/`;		

		// Set visual UI
		// dispatch(isFetchingExplorer(true));		

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {		
			if (json.includes("change_user")) {
				dispatch(setCanChangeUser(true));
			}
		})
		.catch((e) => {
			console.error(e);			
		});
	};
}

function setFakeJson(infos) {
	const {id, projeto, nome, sobrenome, email, username, grupos} = infos;
	const {mariana, brumadinho} = projeto;

	let grps = [];
	
	for ( let i =0; i < (grupos.length); i++) {
		let tmpGroup = {
			value: grupos[i].id,
			label: grupos[i].name
		};
		grps.push(tmpGroup);
	}
	let fakeJson = {
		id: id,
		nome: nome,
		sobrenome: sobrenome,
		email: email,
		mariana: mariana,
		brumadinho: brumadinho,
		username: username,
		password: "",
		confirmpassword: "",
		selectedGroups: grps
	};
	return fakeJson;

}

export function deleteUser(infos) {
	Event('manageUser', 'deleteUser', 'Deletou Usuário');
	return function(dispatch, getState) {
		const URL = `${ROOT}/user/manage_user/`;
		const json = setFakeJson(infos);
		return fetch(URL, {
			method: "DELETE",
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(json)
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => { 
			// sucesso
			prettyAlert("USUARIO DELETADO");
			dispatch(getListUsers());

		})
		.catch((e) => {
			console.error(e);
		});
	};
}
export function redirectToEdit(infos) {
	return function(dispatch, getState) {		
		const {id, projeto, nome, sobrenome, email, username, grupos} = infos;
		const {mariana, brumadinho} = projeto;

		let grps = [];
		
		for ( let i =0; i < (grupos.length); i++) {
			let tmpGroup = {
				value: grupos[i].id,
				label: grupos[i].name
			};
			grps.push(tmpGroup);
		}

		dispatch(setID(id));
		dispatch(setNome(nome));	
		dispatch(setSobrenome(sobrenome));	
		dispatch(setEmail(email));	
		dispatch(setUsername(username));	
		dispatch(setMariana(mariana));	
		dispatch(setBrumadinho(brumadinho));
		dispatch(setEdit(true));
		dispatch(setNewUserGroups(grps));	
		dispatch(push('/admin/change_user'));
	};
		// Set visual UI
		// dispatch(isFetchingExplorer(true));		
}

export function redirectToCreate(infos) {
	return function(dispatch, getState) {
		dispatch(setID(null));
		dispatch(setNome(null));	
		dispatch(setSobrenome(null));	
		dispatch(setEmail(null));	
		dispatch(setUsername(null));	
		dispatch(setMariana(null));	
		dispatch(setBrumadinho(null));
		dispatch(setEdit(false));
		dispatch(setNewUserGroups([]));	
		dispatch(push('/admin/create_new_user'));
	};
		// Set visual UI
		// dispatch(isFetchingExplorer(true));		
}

export function redirectToAccessLog(infos) {
	return function(dispatch, getState) {
		dispatch(push('/admin/access_log'));
	};	
}

function setListUsers(users) {
	return {
		type: "SET_LIST_USERS",
		users
	};	
}

export function setCurrentPage(currentPage) {
	return {
		type: "SET_USERS_CURRENT_PAGE",
		currentPage
	};	
}

export function setAccessCurrentPage(currentPage) {
	return {
		type: "SET_ACCESS_LOG_CURRENT_PAGE",
		currentPage
	};	
}

export function setCanChangeUser(bool) {
	return {
		type: "SET_CAN_CHANGE_USER",
		bool
	};
}

export function setSearchTerms(terms) {
	Event('manageUsers', 'setSearchTerms', 'Definiu palavras-chave: ' + JSON.stringify(terms));
	return {
		type: "SET_USERS_FILTER_TERMS",
		terms
	};	
}

export function setAccessSearchTerms(terms) {
	Event('manageUsers', 'setAccessSearchTerms', 'Definiu palavras-chave: ' + JSON.stringify(terms));
	return {
		type: "SET_ACCESS_LOG_FILTER_TERMS",
		terms
	};	
}


// WEBPACK FOOTER //
// ./src/state/gerenciarUsuarios/actions.js